export default "__VITE_ASSET__BGz8GvLO__"